//React
import { memo, useEffect } from "react";

//Material-UI
import { Card, styled, CardContent } from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

//react-redux
import { useDispatch } from "react-redux";
import { useSelector } from "store";

//lodash
import { get } from "lodash";

//Local Imports
import T from "utils/constants/T";
import { fetchCompanyDetails } from "store/reducers/companyTabDetails";
import { convertDateIntoFrontEndFormat } from "utils/date";

//css
import "./companyDetails.css";

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: "#495057",
  fontWeight: "bolder",
}));
export const StyledBodyTypography = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: "#262626",
}));

export const StyledCardBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "20px 0px",
}));
const CompanyInfo = () => {
  const dispatch = useDispatch();

  const { selectedCompany } = useSelector(
    (state: any) => state.dashboardSearch
  );
  const selectedCompanyId = get(selectedCompany, "_id", "");
  const { role } = useSelector((state) => state.auth) as {
    onBoardedCompanyData: any;
    role: string;
  };

  const {
    contactPerson,
    companyEmail,
    companyPhone,
    companyMemberSince,
    city,
    abn,
    systemName,
    countryName,
    currencyCode,
    currencySymbol,
    editCountryDetails,
    addressCompany,
    postCodeCompany,
    is_business_unit_feature_enable,
  } = useSelector((state: any) => state.companyTabData);

  const formattedDate = convertDateIntoFrontEndFormat(companyMemberSince);
  useEffect(() => {
    dispatch(fetchCompanyDetails(selectedCompanyId));
    console.log(
      "is_business_unit_feature_enable=",
      is_business_unit_feature_enable
    );
  }, [dispatch, selectedCompanyId]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={4} sx={{ height: "100%" }}>
        <Card variant="outlined" className="view-card-height">
          <CardContent>
            <Box>
              <StyledCardBox>
                <StyledTitleTypography>{T.MEMBER_SINCE}</StyledTitleTypography>
                <StyledBodyTypography>{formattedDate}</StyledBodyTypography>
              </StyledCardBox>
              <StyledCardBox>
                <StyledTitleTypography>
                  {T.CONTACT_PERSON}
                </StyledTitleTypography>
                <StyledBodyTypography>{contactPerson}</StyledBodyTypography>
              </StyledCardBox>
              <StyledCardBox>
                <StyledTitleTypography>{T.EMAIL}</StyledTitleTypography>
                <StyledBodyTypography>{companyEmail}</StyledBodyTypography>
              </StyledCardBox>
              <StyledCardBox>
                <StyledTitleTypography>{T.PHONE_NUMBER}</StyledTitleTypography>
                <StyledBodyTypography>{companyPhone}</StyledBodyTypography>
              </StyledCardBox>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={8} sx={{ height: "100%" }}>
        <Card variant="outlined" className="view-card-height">
          <CardContent>
            <StyledBodyTypography sx={{ mb: 2 }}>
              {T.COMPANY_DETAILS}
            </StyledBodyTypography>
            <Divider />
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {countryName === "New Zealand" ? (
                  <StyledTitleTypography>{T.IRD}</StyledTitleTypography>
                ) : (
                  <StyledTitleTypography>{T.ABN}</StyledTitleTypography>
                )}

                <StyledBodyTypography>{abn}</StyledBodyTypography>
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>
                  {T.PAYROLL_SYSTEM}
                </StyledTitleTypography>
                <StyledBodyTypography>{systemName}</StyledBodyTypography>
              </Grid>

              <Grid item xs={12} sx={{ margin: "5px 0px" }}>
                <Divider />
              </Grid>

              <Grid item xs={6}>
                <StyledTitleTypography>
                  {T.ATTENDANCE_SYSTEM}
                </StyledTitleTypography>
                <StyledBodyTypography>{systemName}</StyledBodyTypography>
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>{T.CITY}</StyledTitleTypography>
                <StyledBodyTypography>{city}</StyledBodyTypography>
              </Grid>
              <Grid item xs={12} sx={{ margin: "5px 0px" }}>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>{T.ADDRESS}</StyledTitleTypography>
                <StyledBodyTypography>{addressCompany}</StyledBodyTypography>
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>{T.POST_CODE}</StyledTitleTypography>
                <StyledBodyTypography>{postCodeCompany}</StyledBodyTypography>
              </Grid>
              <Grid item xs={12} sx={{ margin: "5px 0px" }}>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>{T.COUNTRY_NAME}</StyledTitleTypography>
                <StyledBodyTypography>{countryName}</StyledBodyTypography>
              </Grid>
              <Grid item xs={6}>
                <StyledTitleTypography>
                  {T.COUNTRY_CURRENCY}
                </StyledTitleTypography>
                <StyledBodyTypography>
                  {currencyCode} ({currencySymbol})
                </StyledBodyTypography>
              </Grid>
               {(role === "superadmin" || role === "employer") &&
                <>
                  <Grid item xs={12} sx={{ margin: "5px 0px" }}>
                    <Divider />
                  </Grid>

                  <Grid item xs={6}>
                    <StyledTitleTypography>
                      {T.EDIT_COUNTRY}
                    </StyledTitleTypography>
                    <StyledBodyTypography>
                      {editCountryDetails ? T.YES : T.NO}
                    </StyledBodyTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <StyledTitleTypography>
                      {T.ALLOW_BUSINESS_UNIT}
                    </StyledTitleTypography>
                    <StyledBodyTypography>
                      {is_business_unit_feature_enable ? "Yes" : "No"}
                    </StyledBodyTypography>
                  </Grid>
                </>
              }
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default memo(CompanyInfo);
